import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { YearMonthSelector } from "components/ui/YearMonthSelector";
import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";

dayjs.locale("ko");

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 60px;
`;

export const SalesDashboardHeaderSection = () => {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();

  const currentMonthParam =
    searchParams.get("month") || dayjs().format("YYYY-MM");
  const currentDate = dayjs(currentMonthParam);

  const handleDateChange = (newDate: dayjs.Dayjs) => {
    updateUrlParams({
      month: newDate.format("YYYY-MM"),
      innerTab: "",
      innerMembersTab: "",
    });
  };

  return (
    <HeaderWrapper>
      <YearMonthSelector
        currentDate={currentDate}
        onDateChange={handleDateChange}
      />
    </HeaderWrapper>
  );
};
